module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1049-eb2a788869c510b011823e1b646b3218.png";